import { useEffect } from 'react';
import { useAppDispatch } from '@/store';
import appCookiesStorage from '../../../shared/utils/appCookies';
import { COOKIE_KEYS } from '@/constants/cookies';
import { setIsAuthorized } from '@/modules/Auth';

const useSessionRefresh = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const authToken = appCookiesStorage.getItem(COOKIE_KEYS.AUTH_TOKEN);
    if (authToken) {
      dispatch(setIsAuthorized(!!authToken));
    }
  }, []);
};

export default useSessionRefresh;
